import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, Button } from '@flote/ui';
import { useAgeVerification } from '../lib/age-verification';

export function AgeGateDialog() {
  const { isVerified, isChecking, verify } = useAgeVerification();
  const [isDenied, setIsDenied] = useState(false);

  // Don't render while checking localStorage or if already verified
  if (isChecking || isVerified) {
    return null;
  }

  const handleYes = () => {
    verify();
  };

  const handleNo = () => {
    setIsDenied(true);
  };

  return (
    <Dialog open modal>
      <DialogContent
        className="max-w-md"
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex flex-col items-center text-center">
          {/* Flote Logo */}
          <img
            src="/Flote_Word_Red.png"
            alt="Flote"
            className="h-10 mb-6"
          />

          <DialogHeader className="space-y-3">
            <DialogTitle className="text-2xl font-semibold text-gray-900">
              Age Verification Required
            </DialogTitle>
            <DialogDescription className="text-base text-gray-600">
              You must be 21 years of age or older to enter this site.
            </DialogDescription>
          </DialogHeader>

          {/* Legal disclaimer */}
          <p className="mt-4 text-xs text-gray-500 max-w-sm">
            This website contains information about cannabis products intended for adults only.
            By entering, you confirm that you are of legal age in your jurisdiction.
          </p>

          {/* Action area */}
          <div className="mt-8 w-full">
            {isDenied ? (
              <div className="py-4 px-6 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-gray-700 font-medium">
                  Sorry, you must be 21 or older to access this site.
                </p>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                  onClick={handleYes}
                  className="min-w-[140px]"
                >
                  Yes, I'm 21+
                </Button>
                <Button
                  variant="outline"
                  onClick={handleNo}
                  className="min-w-[140px]"
                >
                  No, I'm under 21
                </Button>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
